var newLocation = function newLocation(location) {
  switch (location) {
    case 'top-left':
      {
        return 'top-start';
      }
    case 'top-right':
      {
        return 'top-end';
      }
    case 'bottom-left':
      {
        return 'bottom-start';
      }
    case 'bottom-right':
      {
        return 'bottom-end';
      }
    default:
      return location;
  }
};

export { newLocation };
